import React, { useContext, useEffect, useState } from 'react';
import { SvgComponent, withErrorHandler } from '../../..';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
import FilterListIcon from '@material-ui/icons/FilterList';
import PopupFilter from '../../common/components/PopupFilter/PopupFilter';
import DateFilter from '../../common/components/PopupFilter/FilterComponents/DateFilter';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import moment from 'moment';
import plus from '../../images/icons/CompanyGrading/plus2.svg';
import AddCompany from '../../components/CompanyGrading/AddCompany';
import {
  getAllBanks,
  getCompanyTypeList,
  getIndustries,
  getIndustriesList,
  getSegmentList
} from '../../common/constants/api';
import Card from '../../components/CompanyGrading/Card';
import _ from 'lodash';
import InfiniteScroll from '../../common/components/InfiniteScroll/InfiniteScroll';
import Bank from '../../common/components/PopupFilter/FilterComponents/Bank';
import bankIcon from '../../images/icons/PopUpFilter/bankImg.svg';
import companyTypeIcon from '../../images/icons/PopUpFilter/companyType.svg';
import companyRatingIcon from '../../images/icons/PopUpFilter/companyRating.svg';
import industryRatingIcon from '../../images/icons/PopUpFilter/industryRating.svg';
import segmentRatingIcon from '../../images/icons/PopUpFilter/segmentRating.svg';
import CompanyType from '../../common/components/PopupFilter/FilterComponents/CompanyType';
import CompanyRating from '../../common/components/PopupFilter/FilterComponents/CompanyRating';
import SegmentRating from '../../common/components/PopupFilter/FilterComponents/SegmentRating';
import IndustryRating from '../../common/components/PopupFilter/FilterComponents/IndustryRating';
import { DeveloperDataContext } from '../../../../lems-ui/src/pages/app';

const CompanyGrading = () => {
  const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
  const [showAddCompany, setAddCompany] = useState(false);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [companyTypeOptions, setCompanyTypeOptions] = useState([]);
  const [segmentOptions, setSegmentOptions] = useState([]);

  const [showFilter, setShowFilter] = useState(false);
  const [htmlSelectedFields, setHtmlSelectedFields] = useState('');
  const masterFilters = getFiltersInfo()?.companyGrading;

  const [pageMetadata, setPageMetadata] = useState({ total_data: 0 });
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const context = useContext(DeveloperDataContext);

  const [bank, setBank] = useState('');
  const [companyRatings, setCompanyRatings] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [segmentRatings, setSegmentRatings] = useState('');
  const [industryRatings, setIndustryRatings] = useState('');
  const [fromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(
    moment()
      .add(1, 'days')
      .format('YYYY-MM-DD')
  );

  const [veryFirstCall, setVeryFirstCall] = useState(true);

  const [totalBanks, setTotalBanks] = useState(0);

  const commonUpperStyle = { maxHeight: '20px', maxWidth: '20px' };

  const bankImg = ({ className, style }) => (
    <SvgComponent
      img={bankIcon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );
  const companyTypeImg = ({ className, style }) => (
    <SvgComponent
      img={companyTypeIcon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );
  const companyRatingImg = ({ className, style }) => (
    <SvgComponent
      img={companyRatingIcon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );
  const industryRatingImg = ({ className, style }) => (
    <SvgComponent
      img={industryRatingIcon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );
  const segmentRatingImg = ({ className, style }) => (
    <SvgComponent
      img={segmentRatingIcon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );

  const dataList = [
    {
      img: CalendarTodayIcon,
      title: 'Date',
      name: 'date',
      component: DateFilter
    },
    {
      img: bankImg,
      title: 'Banks',
      name: 'bank',
      component: Bank,
      dependencyData: { multiSelect: true }
    },
    {
      img: companyTypeImg,
      title: 'Company Type',
      name: 'companyType',
      component: CompanyType,
      dependencyData: { multiSelect: true }
    },
    {
      img: companyRatingImg,
      title: 'Company Rating',
      name: 'companyRating',
      component: CompanyRating,
      dependencyData: { multiSelect: true }
    },
    {
      img: segmentRatingImg,
      title: 'Segment Rating',
      name: 'segmentRating',
      component: SegmentRating,
      dependencyData: { multiSelect: true }
    },
    {
      img: industryRatingImg,
      title: 'Industry Rating',
      name: 'industryRating',
      component: IndustryRating,
      dependencyData: { multiSelect: true }
    }
  ];

  const getIndustryData = ({
    from,
    to,
    pageNo,
    pageSize,
    bank,
    companyRating,
    companyType,
    segmentRating,
    industryRating,
    notConsiderOlderData
  }) => {
    setLoading(true);
    getIndustries({
      from: from,
      to: to,
      pageNumber: pageNo,
      pageSize: pageSize,
      bank: bank,
      companyRating: companyRating,
      companyType: companyType,
      segmentRating: segmentRating.length > 0 ? segmentRating : '',
      industryRating: industryRating.length > 0 ? industryRating : ''
    })
      .then(res => {
        setVeryFirstCall(false);
        setPageNumber(res?.page?.number);
        if (notConsiderOlderData) {
          setData(res?._embedded?.industriesForGradingDtoList || []);
        } else {
          setData(
            [...data, ...res?._embedded?.industriesForGradingDtoList] || []
          );
        }
        setLoading(false);
        setPageMetadata({ total_data: res?.page?.totalElements });

        setPageSize(res?.page?.size);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const appliedFilters = async e => {
    if (veryFirstCall) return;
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      companyGrading: e
    });
    setPageNumber(0);
    let startDate = moment(e?.dateFilter?.startDate).format('YYYY-MM-DD');
    let endDate = moment(e?.dateFilter?.endDate)
      .add(1, 'days')
      .format('YYYY-MM-DD');
    let bankId = Object.keys(e?.bank || {}).toString();
    let companyType = Object.keys(e?.companyType || {})?.toString();
    let companyRating = Object.keys(e?.companyRating || {})?.toString();
    let segmentRating = [];
    Object.keys(e?.segmentRating || {})?.map(each => {
      if (each === '1') {
        segmentRating.push(true);
      } else {
        segmentRating.push(false);
      }
    });
    let industryRating = [];
    Object.keys(e?.industryRating || {})?.map(each => {
      if (each === '1') {
        industryRating.push(true);
      } else {
        industryRating.push(false);
      }
    });
    getIndustryData({
      from: startDate,
      to: endDate,
      pageNo: 0,
      pageSize: pageSize,
      bank: bankId,
      companyType: companyType,
      companyRating: companyRating,
      segmentRating: segmentRating.length > 0 ? segmentRating : '',
      industryRating: industryRating.length > 0 ? industryRating : '',
      notConsiderOlderData: true
    });
    setFromDate(startDate);
    setToDate(endDate);
    setBank(bankId);
    setCompanyRatings(companyRating);
    setCompanyType(companyType);
    setSegmentRatings(segmentRating);
    setIndustryRatings(industryRating);
  };

  const getOptionsList = () => {
    getAllBanks()
      .then(res => setTotalBanks(res.length))
      .catch(() => {});
    let names = [];
    getIndustriesList()
      .then(res => {
        names = [];
        res.map(each => {
          names.push({
            id: each?.id,
            value: each?.name,
            label: each?.name !== 'IT' ? _.capitalize(each?.name) : each?.name
          });
        });
        setIndustryOptions(names);
      })
      .catch(err => {});
    getCompanyTypeList()
      .then(res => {
        names = [];
        res.map(each => {
          names.push({
            id: each?.id,
            value: each?.name,
            label: each?.name
          });
        });
        setCompanyTypeOptions(names);
      })
      .catch(err => {});
    getSegmentList()
      .then(res => {
        names = [];
        res.map(each => {
          names.push({
            id: each?.id,
            value: each?.name,
            label: _.capitalize(each?.name)
          });
        });
        setSegmentOptions(names);
      })
      .catch(err => {});
  };

  useEffect(() => {
    let startDate = moment(masterFilters?.dateFilter?.startDate).format(
      'YYYY-MM-DD'
    );
    let endDate = moment(masterFilters?.dateFilter?.endDate)
      .add(1, 'days')
      .format('YYYY-MM-DD');
    let banks = Object.keys(masterFilters?.bank || {})?.toString();
    let companyRating = Object.keys(
      masterFilters?.companyRating || {}
    ).toString();
    let companyTypes = Object.keys(masterFilters?.companyType || {}).toString();
    let segmentRating = [];
    Object.keys(masterFilters?.segmentRating || {})?.map(each => {
      if (each === '1') {
        segmentRating.push(true);
      } else {
        segmentRating.push(false);
      }
    });
    let industryRating = [];
    Object.keys(masterFilters?.industryRating || {})?.map(each => {
      if (each === '1') {
        industryRating.push(true);
      } else {
        industryRating.push(false);
      }
    });
    getIndustryData({
      from: startDate || fromDate,
      to: endDate || toDate,
      pageNo: 0,
      pageSize: pageSize,
      bank: banks || bank,
      companyRating: companyRating || companyRatings,
      companyType: companyTypes || companyType,
      segmentRating:
        segmentRating.length > 0 ? segmentRating : '' || segmentRatings,
      industryRating:
        industryRating.length > 0 ? industryRating : '' || industryRatings,
      notConsiderOlderData: true
    });
    setFromDate(startDate);
    setToDate(endDate);
    setBank(bank);
    setCompanyRatings(companyRating);
    setCompanyType(companyTypes);
    setSegmentRatings(segmentRating);
    setIndustryRatings(industryRating);
  }, [context.appData.companyReload]);

  useEffect(() => {}, [data]);

  const handlePagnation = () => {
    if (veryFirstCall) return;
    if (pageSize * (pageNumber + 1) >= pageMetadata.total_data) return;
    getIndustryData({
      from: fromDate,
      to: toDate,
      pageNo: pageNumber + 1,
      pageSize: pageSize,
      bank: bank,
      companyRating: companyRatings,
      companyType: companyType,
      segmentRating: segmentRatings,
      industryRating: industryRatings
    });
  };

  useEffect(() => {
    getOptionsList();
  }, []);

  return (
    <div className="w-full bg-navy-600">
      <div className="flex w-full">
        <Sidebar />
        <div className="w-full max-h-screen overflow-auto pt-3 pl-3 pr-4 pb-4">
          <Header />
          <div className="flex justify-between mx-1">
            <p className="text-base font-sans font-bold text-black-400 w-32">
              All Comapny
            </p>
            <div className="w-full text-right">
              <button
                className=" w-48 h-12  mt-2 cursor-pointer text-center text-white bg-tealCol-100 rounded-md ml-auto"
                onClick={() => {
                  setShowAddCompanyModal(true), setAddCompany(true);
                }}
              >
                <div className="mx-auto inline-flex ">
                  <img className="block mr-2 -mt-px " src={plus} alt="+" />
                  <span className="text-base py-3 block">Add Company</span>
                </div>
              </button>
            </div>
            {showAddCompany ? (
              <AddCompany
                showModal={showAddCompanyModal}
                setShowModal={setShowAddCompanyModal}
                setAddCompany={setAddCompany}
                industryOptions={industryOptions}
                companyTypeOptions={companyTypeOptions}
                segmentOptions={segmentOptions}
              />
            ) : null}
          </div>
          <div className="w-full bg-white p-3 rounded-xl shadow mt-3">
            <div
              className="cursor-pointer py-1"
              style={{ width: '150px' }}
              onClick={() => setShowFilter(true)}
            >
              <div className="border border-grey-2235 rounded flex py-2 px-4">
                <p className="text-grey-2236 font-roboto font-normal text-sm">
                  Filter
                </p>
                <div className="table ml-auto ">
                  <FilterListIcon style={{ color: '#8a939e' }} />
                </div>
              </div>
            </div>
            <div className="w-full">
              {Object.keys(htmlSelectedFields || {}).map(
                each => htmlSelectedFields[each]
              )}
            </div>
          </div>
          <InfiniteScroll
            bottomLocation={200}
            debounceTime={100}
            handleScrollsuccess={handlePagnation}
            showDefaultLoader={false}
          >
            <div className="w-full mt-5 flex flex-wrap gap-x-3 gap-y-4">
              {data.map((res, i) => (
                <Card
                  key={`companycard${i}`}
                  data={res}
                  industryOptions={industryOptions}
                  companyTypeOptions={companyTypeOptions}
                  segmentOptions={segmentOptions}
                  totalBanks={totalBanks}
                />
              ))}
            </div>
            {!loading &&
              data?.length != 0 &&
              data?.length == pageMetadata?.total_data && (
                <div className="table text-center mx-auto mt-5">
                  No More Data Available!
                </div>
              )}
            {!loading && data?.length == 0 && (
              <div className="table text-center mx-auto">
                No Data Available!
              </div>
            )}
          </InfiniteScroll>
        </div>
      </div>
      <PopupFilter
        show={showFilter}
        setShow={setShowFilter}
        dataList={dataList}
        handleApply={appliedFilters}
        handleToastBlock={e => setHtmlSelectedFields(e)}
        masterFiltersData={masterFilters}
      />
    </div>
  );
};

export default withErrorHandler(CompanyGrading);
